import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { Capacitor } from "@capacitor/core";
/**
 * @author E45597 Aryamitra Chaudhuri
 * @description Trigger function for logging onclick cmed event on firebase.
 */

export const CMEDfirebaseLogEvent = (
  CMEDComponentName: string,
  eventName: string,
): void => {
  FirebaseAnalytics.logEvent({
    name: CMEDComponentName,
    params: {
      event_name: eventName,
      device_type: Capacitor.getPlatform(),
      device_app_id: Capacitor.isNativePlatform()
        ? process.env.REACT_APP_APP_ID
        : "not_native",
    },
  });
};
